/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamDropdownByDisciplineAndCompany200,
  GetApiV1ExamDropdownByDisciplineAndCompany401,
  GetApiV1ExamDropdownByDisciplineAndCompany500,
  GetApiV1ExamDropdownByDisciplineAndCompanyQueryParams,
  GetApiV1ExamDropdownByDisciplineAndCompanyQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamDropdownByDisciplineAndCompany.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

export const getApiV1ExamDropdownByDisciplineAndCompanyQueryParamsSchema =
  z.object({
    disciplineId: z.optional(z.coerce.number().int()),
    companyId: z.optional(z.coerce.number().int()),
    teacherEvaluation: z.boolean().default(false),
    instructorEvaluation: z.boolean().default(false),
  }) as unknown as ToZod<GetApiV1ExamDropdownByDisciplineAndCompanyQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamDropdownByDisciplineAndCompany200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamDropdownByDisciplineAndCompany200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamDropdownByDisciplineAndCompany401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDropdownByDisciplineAndCompany401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamDropdownByDisciplineAndCompany500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamDropdownByDisciplineAndCompany500>;

export const getApiV1ExamDropdownByDisciplineAndCompanyQueryResponseSchema =
  z.lazy(
    () => getApiV1ExamDropdownByDisciplineAndCompany200Schema,
  ) as unknown as ToZod<GetApiV1ExamDropdownByDisciplineAndCompanyQueryResponse>;
